export interface Language {
    code: string
    name: string
}

export const LANGUAGES: Language[] = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'ko',
        name: '한국'
    },
    {
        code: 'th',
        name: 'ไทย'
    },
    {
        code: 'ja',
        name: '日本'
    },
    {
        code: 'vi',
        name: 'Tiếng Việt'
    }
]
